import { configureStore } from "@reduxjs/toolkit";
import { persistReducer, persistStore } from "redux-persist";
import storage from "redux-persist/lib/storage";
import { combineReducers } from "@reduxjs/toolkit"; // 리듀서 결합을 위해 추가

// import reduxReducer_slide from './reduxToolkit/reduxSlice';
// import reduxReducer_mun from "./reduxToolkit/reduxMun";
// import reduxKrkwic from './reduxToolkit/reduxKrkwic';

import reduxReducer_slide from './reduxToolkit/reduxSlice';
import reduxReducer_aca from "./reduxToolkit/reduxAca";
import reduxReducer from "./reduxToolkit/redux";
import reduxReducer_board from "./reduxToolkit/reduxBoard";
import reduxReducer_payment from "./reduxToolkit/reduxPayment";


// Redux Persist 설정
const persistConfig = {
    key: "root",
    storage, // localStorage에 저장
    whitelist: [],  // 저장할 슬라이스 없음
    // whitelist: ["reduxStore", "reduxStoreAca", "reduxStoreMun"], // 저장할 슬라이스만 지정
    // blacklist: ["reduxStore.isLogined"], // 복원에서 제외할 특정 상태
};

// combineReducers로 리듀서 결합
const rootReducer = combineReducers({
    reduxStoreAca: reduxReducer_aca,
    reduxStore: reduxReducer,
    reduxStoreBoard: reduxReducer_board,
    reduxPayment: reduxReducer_payment,
});

// Persist Reducer 생성
const persistedReducer = persistReducer(persistConfig, rootReducer);

// Redux Store 생성
export const store2 = configureStore({
    reducer: persistedReducer,
    middleware: (getDefaultMiddleware) =>
        getDefaultMiddleware({
            serializableCheck: {
                // Redux Persist의 액션을 무시하도록 설정
                ignoredActions: ["persist/PERSIST", "persist/REHYDRATE"],
            },
        }),
});


// Persistor 생성
export const persistor = persistStore(store2);
